import { ErrorOutline } from "@mui/icons-material";
import { alpha, Button, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { renderError } from "../../../util/ErrorUtils";
import { ApiStateResponseError } from "../../../state/Store";

interface Props {
    error: string | ApiStateResponseError;
    retry?: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
    wrapper: {
        display: "flex",
        justifyContent: "center",
        margin: "4rem auto",
        color: "rgba(0, 0, 0, 0.87)",
        borderRadius: "4px",
        alignItems: "center",
        flexDirection: "column",
        padding: "2rem 2rem 1rem 2rem",
        minWidth: "480px",
        backgroundColor: alpha(theme.palette.error.main, 0.15)
    },
    icon: {
        marginBottom: "1.5rem",
        fontSize: "2rem",
        color: theme.palette.error.main
    },
    error: {
        fontWeight: 500,
        fontSize: "1rem",
        marginBottom: "1rem",
        maxWidth: "640px"
    },
    button: {
        marginTop: "1rem",
        fontWeight: "normal",
        whiteSpace: "nowrap",
        textTransform: "none",
        "&:active": {
            backgroundColor: "rgba(0, 0, 0, 0.18)"
        }
    }
}));

const SettingsPageError: React.FC<Props> = props => {
    const classes = useStyles();

    const errorString = typeof props.error === "string" ? props.error : renderError(props.error);

    return (
        <div className={classes.wrapper}>
            <ErrorOutline className={classes.icon} />
            <span className={classes.error}>
                {errorString}
            </span>
            {props.retry && (
                <Button
                    disableRipple
                    disableTouchRipple
                    disableFocusRipple
                    disableElevation
                    onClick={props.retry}
                    className={classes.button}
                    variant="outlined"
                    size="medium">
                    Erneut versuchen
                </Button>
            )}
        </div>
    );
};

export default SettingsPageError;
